export default __webpack_public_path__ + "static/media/ic-product-black.620dee48.svg";